
import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';

import { Field } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import { ValidationError } from '../';


import arrow from './arrow.png';
import css from './CustomSelectFormField.module.css';


const CustomSelectComponent = props => {

  const {
    rootClassName,
    name,
    id,
    label,
    options,
    placeholder,
    input,
    meta,
    otherOption,
  } = props;

  const { onChange, value, onBlur } = input;

  const allOptions = otherOption ? [...options, otherOption] : options;

  const wrapperRef = useRef(null);
  const [showOptions, setShowOptions] = useState(false);
  const [touched, setTouched] = useState(false);
  const [selectedOption, setSelectedOption] = useState(value || null);

  const { valid, invalid, error } = meta;
  const hasError = touched && invalid && error;

  const selectClasses = classNames(css.selectInput, {
    [css.selectSuccess]: valid,
    [css.selectError]: hasError,
  });

  useEffect(() => {
    const handleClickOutside = event => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const selectedOptionLabel =
    selectedOption && allOptions.find(o => o.key === selectedOption)?.label;

  const findOptionByKey = eventKey => {
    const lowerEventKey = eventKey.toLowerCase();
    const option = allOptions.find( o =>
        `${id.toLowerCase()}-${o.key.toLowerCase()}`.startsWith(`${id.toLowerCase()}-${eventKey.toLowerCase()}`)
      );

    return option;
  };

  return (
    <div
      className={classNames(css.root, rootClassName)}
      onKeyPress={ event => {
        if( showOptions && event.key ){
          const option = findOptionByKey( event.key );

          if( option ){
            const optionElement = document.getElementById(`${id.toLowerCase()}-${option.key.toLowerCase()}`);

            if( optionElement ){
              optionElement.scrollIntoView();
            }
          }
        }

        event.stopPropagation();
      }}
    >
      {label ? <label htmlFor={id}>{label}</label> : null}
      <div
        className={selectClasses}
        onClick={() => {
          setShowOptions(!showOptions);
          if (!value || !selectedOption) {
            setTouched(true);
          }
        }}
        ref={wrapperRef}
        tabIndex="0"
      >
        {selectedOption ? (
          <div className={css.selectedOption}>
            {selectedOptionLabel}
            <img src={arrow} className={css.arrow} alt="arrow" />
          </div>
        ) : (
          <div className={css.selectedOption}>
            <div className={css.placeholder}>
              {placeholder || <FormattedMessage id="CustomSelectFormField.placeholder" />}
            </div>
            <img src={arrow} className={css.arrow} alt="arrow" />
          </div>
        )}

        {showOptions && (
          <div className={css.options}>
            {allOptions.map(o => (
              <div
                key={o.key}
                id={`${id.toLowerCase()}-${o.key.toLowerCase()}`}
                className={css.option}
                onClick={() => {
                  onChange(o.key); // Update Final Form's value
                  setSelectedOption(o.key);
                  setShowOptions(false);
                  setTouched(true);
                }}
              >
                {o.label}
              </div>
            ))}
          </div>
        )}
      </div>
      <ValidationError fieldMeta={{ touched, error: meta.error }} />
    </div >
  );
};

const CustomSelectFormField = props => {
  return <Field component={CustomSelectComponent} {...props} />;
};

export default CustomSelectFormField;
